import React, { useEffect, useRef, useState } from 'react';
import './Hero.css';
import { useLanguage } from '../context/LanguageContext';

const Hero = () => {
  const { t } = useLanguage();
  const video1Ref = useRef(null);
  const video2Ref = useRef(null);
  const [activeVideo, setActiveVideo] = useState(1);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  // Crossfade loop - when one video nears end, fade to the other starting fresh
  useEffect(() => {
    const video1 = video1Ref.current;
    const video2 = video2Ref.current;
    if (!video1 || !video2) return;

    const handleTimeUpdate = (videoNum, video, otherVideo) => {
      // When video is 0.5 seconds from end, start crossfade
      if (video.duration && video.currentTime >= video.duration - 0.5) {
        if (activeVideo === videoNum) {
          otherVideo.currentTime = 0;
          otherVideo.play();
          setActiveVideo(videoNum === 1 ? 2 : 1);
        }
      }
    };

    const onTimeUpdate1 = () => handleTimeUpdate(1, video1, video2);
    const onTimeUpdate2 = () => handleTimeUpdate(2, video2, video1);

    video1.addEventListener('timeupdate', onTimeUpdate1);
    video2.addEventListener('timeupdate', onTimeUpdate2);

    // Start video1
    video1.play();

    return () => {
      video1.removeEventListener('timeupdate', onTimeUpdate1);
      video2.removeEventListener('timeupdate', onTimeUpdate2);
    };
  }, [activeVideo]);

  return (
    <section className="hero" id="home">
      {/* Video Background - Crossfade Loop */}
      <div className="hero-video-bg">
        <video 
          ref={video1Ref}
          muted 
          playsInline
          preload="auto"
          className={`hero-video ${activeVideo === 1 ? 'active' : ''}`}
        >
          <source src="/bottle-spin.mp4" type="video/mp4" />
        </video>
        <video 
          ref={video2Ref}
          muted 
          playsInline
          preload="auto"
          className={`hero-video ${activeVideo === 2 ? 'active' : ''}`}
        >
          <source src="/bottle-spin.mp4" type="video/mp4" />
        </video>
      </div>

      {/* Content Overlay */}
      <div className={`hero-content ${isVisible ? 'visible' : ''}`}>
        <h1 className="hero-title">
          <span className="title-line">{t.hero.title1}</span>
          <span className="title-line accent">{t.hero.title2}</span>
        </h1>
        
        <p className="hero-subtitle">
          {t.hero.subtitle}
        </p>

        <div className="hero-cta">
          <a href="#collection" className="cta-primary">
            <span>{t.hero.ctaPrimary}</span>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2"/>
            </svg>
          </a>
        </div>
      </div>

      {/* Bottom Stats Bar */}
      <div className={`hero-bottom-bar ${isVisible ? 'visible' : ''}`}>
        <div className="stat">
          <span className="stat-value">{t.hero.stat1Value}</span>
          <span className="stat-label">{t.hero.stat1Label}</span>
        </div>
        <div className="stat-divider"></div>
        <div className="stat">
          <span className="stat-value">{t.hero.stat2Value}</span>
          <span className="stat-label">{t.hero.stat2Label}</span>
        </div>
        <div className="stat-divider"></div>
        <div className="stat">
          <span className="stat-value">{t.hero.stat3Value}</span>
          <span className="stat-label">{t.hero.stat3Label}</span>
        </div>
      </div>

      <div className="hero-scroll-indicator">
        <span className="scroll-text">{t.hero.scroll}</span>
        <div className="scroll-line">
          <div className="scroll-dot"></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
